import detect from '../../core/detect'

export default class ColumnSlider {
  get CLASSES() {
    return {
      isActive: 'is-active',
      isVisible: 'is-visible',
      isInvisible: 'is-invisible',
    }
  }

  get DEFAULT_OPTIONS() {
    return {
      wrapperClass: 'slides',
      slideClass: 'slide',
      slideActiveClass: 'is-selected',
      slidesPerView: 1,
      loop: true,
      speed: 500,
      effect: 'fade',
      allowTouchMove: false,
      fadeEffect: {
        crossFade: true
      },
      autoplay: {
        delay: 4500,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: '.column-slider-arrow-next',
      },
      on: {
        slideChange: () => {
          this.progress();
        },
      },
    }
  }

  constructor() {
    this.$columnSlider = document.querySelector('[data-column-slider]')
    if(!this.$columnSlider) return;
    this.$column = document.querySelector('[data-column]')
    this.$sliderMainEl = document.querySelector('[data-column-slider-el="main"]')
    this.$sliderSubEl = document.querySelector('[data-column-slider-el="sub"]')
    this.$slidesEl = document.querySelector('[data-column-slider-el="slides"]')
    this.$nextBtn = document.querySelector('[data-column-slider-el="next"]')
    this.timeout = null;
    this.sliderMain;
    this.sliderSub;
    this.init();
  }

  init() {
    this.create();
    this.onNextClick();
    this.onScroll();
    this.onResize();
  }

  create() {
    this.sliderMain = new Swiper(this.$sliderMainEl, {
      ...this.DEFAULT_OPTIONS,
    });
    this.sliderMain.autoplay.stop()
    
    this.clone();
    
    this.sliderSub = new Swiper(this.$sliderSubEl, {
      ...this.DEFAULT_OPTIONS,
      initialSlide: 1,
    });
    this.sliderSub.autoplay.stop()

    setTimeout(() => {
      this.$nextBtn.classList.remove(this.CLASSES.isActive);
    });
  }

  clone() {
    this.$cloneSlides = this.$slidesEl.cloneNode(true);
    this.$sliderSubEl.appendChild(this.$cloneSlides);
  }

  progress() {
    this.$nextBtn.classList.remove(this.CLASSES.isActive);

    setTimeout(() => {
      this.$nextBtn.classList.add(this.CLASSES.isActive);

      if (this.timeout) {
        clearTimeout(this.timeout);
      }

      this.timeout = setTimeout(() => {
        this.$nextBtn.classList.remove(this.CLASSES.isActive);
        this.timeout = null;
      }, 5000);
    });
  }

  onNextClick() {
    this.$nextBtn.addEventListener('click', () => {
      this.progress();
    });
  }

  onScroll() {
    ScrollTrigger.create({
      trigger: this.$column,
      start: 'top bottom',
      once: true,
      onEnter: () => {
        this.sliderMain.slideToLoop(0)
        this.sliderSub.slideToLoop(1)
      },
    });

    ScrollTrigger.create({
      trigger: this.$columnSlider,
      start: 'top 80%',
      once: true,
      onEnter: () => {
        this.$columnSlider.classList.add(this.CLASSES.isVisible);
        setTimeout(() => this.$columnSlider.classList.remove(this.CLASSES.isVisible), 4500);
        this.$nextBtn.classList.remove(this.CLASSES.isActive);
        this.sliderMain.autoplay.start()
        this.sliderSub.autoplay.start()
        this.progress();
      },
    });
  }

  onResize() {
    if (detect.isMobile()) return;
    window.addEventListener('resize', () => {
      setTimeout(() => this.$nextBtn.click(), '1000');
    });
  }
}
